/* @flow */
export const validation = {
  buttons: {
    min: 1,
    max: 2
  }
}
